<nav class="navbarDesktop">
  <div class="flex flex-wrap items-center justify-between px-4 h-16">
      <a href="{{ env }}" class="flex items-center space-x-3 h-full">
          <img src="../../../../assets/img/solfium/new-logo-solfium.svg" class="h-8" alt="Logo" />
      </a>
      
      <ul>
        <li class="dropdown-arrow">
          <button class="flex gap-8 items-center text-14px" [matMenuTriggerFor]="menu">
            <mat-icon class="material-symbols-outlined languageIcon">language</mat-icon>
            {{ getLanguageName(flag_select) }}
            <mat-icon class="icon-size-3 material-symbols-rounded">keyboard_arrow_down</mat-icon>
          </button>
  
          <mat-menu #menu="matMenu">
              <button *ngFor="let lenguage of array_lenguage" mat-menu-item (click)="changeLanguage(lenguage)" onclick="updateIframeSolfiumNews();">
                  {{ getLanguageName(lenguage) }}
              </button>
          </mat-menu>
        </li>
      </ul>
  </div>      
</nav>